import { Observable, of } from 'rxjs';

import { IModuleColumnI18n, ModuleColumnI18n } from './module-column-i18n';

export interface IModuleColumn {
	readonly id: string;
	readonly position: number;
	readonly localizations: ReadonlyArray<IModuleColumnI18n>;
	readonly localization$: Observable<IModuleColumnI18n>;
}

export class ModuleColumn implements IModuleColumn {
	private _id: string;
	private _position: number;
	private _localizations: ModuleColumnI18n[];
	private _localization$: Observable<ModuleColumnI18n>;

	constructor(
		id: string,
		position: number,
		localizations: ModuleColumnI18n[],
		localization$: Observable<ModuleColumnI18n> = of(null)
	) {
		this._id = id;
		this._position = position;
		this._localizations = localizations;
		this._localization$ = localization$;
	}

	public get id(): string {
		return this._id;
	}

	public get position(): number {
		return this._position;
	}

	public get localizations(): ModuleColumnI18n[] {
		return this._localizations;
	}

	public get localization$(): Observable<ModuleColumnI18n> {
		return this._localization$;
	}
}
